export const API_BASE_URL = '/wom/v1';
